import React from 'react'
import { Route } from 'react-router-dom'
import { ROUTES } from '../../shared/constants'
import { Root } from '../../shared/styles'
import SalesAnalytics from './Sales'
import PurchaseAnalytics from './Purchase'

export default () =>
    <Root>
        <Route exact path={ROUTES.ANALYTICS_SALES} component={SalesAnalytics} />
        <Route exact path={ROUTES.ANALYTICS_PURCHASE} component={PurchaseAnalytics} />
    </Root>

export { SalesAnalytics, PurchaseAnalytics }